import React, { useEffect, useMemo, useState } from 'react';
import { useData } from '../data/DataProvider';
import { usePortalClient } from './usePortalClient';
import { useToast } from '../shared/components/ToastProvider';
import EmptyState from '../shared/components/EmptyState';
import Skeleton from '../shared/components/Skeleton';
import { date } from '../shared/formatters';
import PortalHeader from './PortalHeader';

export default function Chat() {
  const { data, add } = useData();
  const { client } = usePortalClient();
  const { notify } = useToast();
  const [loading, setLoading] = useState(true);
  const [draft, setDraft] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 220);
    return () => clearTimeout(timer);
  }, []);

  const messages = useMemo(
    () => data.messages
      .filter((item) => item.client_id === client.id)
      .sort((a, b) => new Date(a.created_at) - new Date(b.created_at)),
    [client.id, data.messages]
  );

  function sendMessage(event) {
    event.preventDefault();

    if (!draft.trim()) {
      notify('Write a message before sending.', 'error');
      return;
    }

    add('messages', {
      id: `message_${Date.now()}`,
      client_id: client.id,
      sender: 'client',
      name: client.name.split(' ')[0],
      body: draft.trim(),
      created_at: new Date().toISOString(),
      read_at: null
    });

    setDraft('');
    notify('Message sent to Premiere Plumbing');
  }

  if (loading) {
    return <Skeleton rows={4} />;
  }

  return (
    <>
      <PortalHeader
        eyebrow="Direct support"
        title="Messages"
        description="Message the Premiere team about your property or upcoming work."
      />

      <section className="portal-card chat-panel">
        <div className="chat-contact">
          <div className="small-avatar dark">PP</div>
          <div>
            <strong>Premiere team</strong>
            <span>Usually replies within one working day</span>
          </div>
        </div>

        {!messages.length ? (
          <EmptyState title="Start a conversation" message="Send a message and the team will get back to you." />
        ) : (
          <div className="chat-list">
            {messages.map((message) => (
              <div className={`message ${message.sender}`} key={message.id}>
                <small>{message.name} · {date(message.created_at)}</small>
                <p>{message.body}</p>
              </div>
            ))}
          </div>
        )}

        <form className="chat-compose" onSubmit={sendMessage}>
          <input
            value={draft}
            onChange={(event) => setDraft(event.target.value)}
            placeholder="Write a message…"
          />
          <button className="primary-button">Send</button>
        </form>
      </section>
    </>
  );
}